export default __webpack_public_path__ + "static/media/Leggings of a Thousand Blossoms.4dc91e36.jpg";